import React from 'react';
import styled from 'styled-components';
import {VideoInfo} from 'shared/components/VideoPlayer/entity/VideoInfo';

interface ThumbnailProps {
    videoInfo: VideoInfo;
    watched: boolean;
    compact?: boolean;
}

export const Thumbnail = ({
    videoInfo,
    watched,
    compact = false,
}: ThumbnailProps) => (
    <ThumbnailFrame $compact={compact}>
        <Image src={videoInfo.thumbnail} alt="" />
        <PlayBadge $compact={compact} aria-hidden="true">
            ▶
        </PlayBadge>
        {watched ? (
            <WatchedBadge $compact={compact}>
                {compact ? '✓' : '✓ Watched'}
            </WatchedBadge>
        ) : null}
        <Duration>{videoInfo.duration}</Duration>
    </ThumbnailFrame>
);

const ThumbnailFrame = styled.div<{$compact: boolean}>`
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #d3e2ec;
    border-radius: ${({$compact}) => ($compact ? '8px' : '0')};
    overflow: hidden;
    flex-shrink: 0;
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`;

const PlayBadge = styled.span<{$compact: boolean}>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: grid;
    place-items: center;
    width: ${({$compact}) => ($compact ? '24px' : '34px')};
    height: ${({$compact}) => ($compact ? '24px' : '34px')};
    padding-left: 2px;
    border-radius: 50%;
    font-size: ${({$compact}) => ($compact ? '9px' : '12px')};
    color: ${({theme}) => theme.colors.primary.main};
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
`;

const WatchedBadge = styled.span<{$compact: boolean}>`
    position: absolute;
    top: 6px;
    left: 6px;
    padding: ${({$compact}) => ($compact ? '0 5px' : '1px 8px')};
    border-radius: 20px;
    font-size: 10px;
    font-weight: 600;
    color: #fff;
    background: #28a745;
`;

const Duration = styled.span`
    position: absolute;
    right: 6px;
    bottom: 6px;
    padding: 0 5px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    background: rgba(0, 0, 0, 0.75);
`;
